/**
 * Currency Initializer
 * 
 * Este script se encarga de inicializar el sistema de cambio de moneda
 * y asegurarse de que las tasas de cambio se carguen correctamente.
 */

(function() {
  // Función para inicializar el sistema de cambio de moneda
  function initCurrencySystem() {
    // Verificar si el gestor de tasas de cambio está disponible
    if (typeof window.exchangeRatesManager === 'undefined') {
      console.log('Creating exchange rates manager');
      // Crear el gestor de tasas de cambio si no existe
      if (typeof ExchangeRatesManager !== 'undefined') {
        window.exchangeRatesManager = new ExchangeRatesManager({
          baseCurrency: 'EUR',
          cacheDuration: 86400000 // 24 horas
        });
      } else {
        console.error('ExchangeRatesManager not defined');
        return;
      }
    }

    // Forzar la actualización de las tasas de cambio
    window.exchangeRatesManager.forceRefresh()
      .then(function(rates) {
        console.log('Exchange rates loaded:', rates);
        
        // Actualizar todos los selectores de moneda con las nuevas tasas
        updateCurrencySelectors(rates);
      })
      .catch(function(error) {
        console.error('Failed to load exchange rates:', error);
      });
  }

  // Función para actualizar los selectores de moneda con las nuevas tasas
  function updateCurrencySelectors(rates) {
    if (!rates) return;
    
    // Buscar todos los enlaces de moneda en los selectores
    const currencyLinks = document.querySelectorAll('a[data-code]');
    
    if (currencyLinks.length === 0) {
      console.log('No currency links found, will try again later');
      // Intentar de nuevo más tarde si no se encuentran enlaces
      setTimeout(function() {
        updateCurrencySelectors(rates);
      }, 500);
      return;
    }
    
    // Actualizar cada enlace con la tasa correspondiente
    currencyLinks.forEach(function(link) {
      const code = (link.dataset.code || '').toUpperCase();
      if (code && rates[code]) {
        // Actualizar el atributo data-rate con la nueva tasa
        link.dataset.rate = rates[code].toString();
        console.log('Updated rate for ' + code + ': ' + rates[code]);
      }
    });
    
    // Notificar que las tasas han sido actualizadas
    document.dispatchEvent(new CustomEvent('exchange:rates:updated', { 
      detail: { rates: rates, base: 'EUR' } 
    }));
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initCurrencySystem, 100);
    });
  } else {
    // El DOM ya está listo
    setTimeout(initCurrencySystem, 100);
  }
  
  // También inicializar cuando la ventana esté completamente cargada
  window.addEventListener('load', function() {
    setTimeout(initCurrencySystem, 500);
  });
})();
